import { DECISION, DECISION_USER, SUPPORT } from 'business/constants';
import { useClientHasModule, useIsEssential } from 'hooks/client';
import { useUserHasRole } from 'hooks/user';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ModuleWithCallToAction from './CallToActions/ModuleWithCallToAction';
import ModuleForbidden from './RolesCheck/ModuleForbidden';
import { ModuleWithRolesCheck } from './RolesCheck/ModuleWithRolesCheck';
import routes from 'components/App/components/routes';

type Props = {
    children: React.ReactNode;
};

/**
 * Component to wrap the indicators routes to check:
 *  - if client has access to module, else display CTA
 *  - if client does not have essential, else display forbidden page
 *  - if user has access to module, else display forbidden page
 *  - support users always have access to decision
 */
const IndicatorsWithAccessCheck = ({ children }: Props): JSX.Element => {
    const { t } = useTranslation();
    const hasDecision = useClientHasModule(DECISION);
    const hasEssential = useIsEssential();
    const isSupportUser = useUserHasRole(SUPPORT);
    const isDecisionUser = useUserHasRole(DECISION_USER);

    if (isSupportUser) return <>{children}</>;
    if (hasEssential)
        return <ModuleForbidden title={t('moduleForbidden.page')} />;

    return (
        <ModuleWithCallToAction
            hasModule={hasDecision}
            redirectionUrl={routes.decisionCta}
        >
            <ModuleWithRolesCheck
                module="decision"
                hasModule={hasDecision}
                isModuleUser={isDecisionUser}
            >
                {children}
            </ModuleWithRolesCheck>
        </ModuleWithCallToAction>
    );
};

export default IndicatorsWithAccessCheck;
